<div class="empty-state">
  <mat-icon>dashboard</mat-icon>
  <p>Dashboard coming soon </p>
</div>
